import { Container, makeStyles, Paper } from "@material-ui/core";

import { Cooperation } from "../../gardener/gardener.model";
import { LevelIconAndText } from "../your-level/LevelIconAndText";
import { determineLevelText, determineNextCooperationLevel } from "../utility";
import { BlockingProgressItemHeader } from "./BlockingProgressHeader";

const useStyles = makeStyles(theme => ({
    card: {
        overflow: "hidden",
        padding: "24px",

        "& > *": {
            marginBottom: "24px",

            "&:last-child": {
                marginBottom: 0,
            },
        },
    },
    paragraph: {
        fontSize: "16px",
        fontWeight: 400,
        color: "#4A4A4A",

        "& > span": {
            fontWeight: 600,
        },

        [theme.breakpoints.down(500)]: {
            textAlign: "center",
        },
    },
}));

interface FailedTaskItemProps {
    cooperationLevel: Exclude<Cooperation["level"], "platin">;
    tasksUntilNextLevel: number;
    onClose?: () => void;
}

export const FailedTaskItem = (props: FailedTaskItemProps) => {
    const classes = useStyles();
    const { cooperationLevel, tasksUntilNextLevel, onClose } = props;

    const nextCooperationLevel = determineNextCooperationLevel(cooperationLevel);
    const levelText = determineLevelText(cooperationLevel);

    return (
        <Container maxWidth="sm" disableGutters>
            <Paper className={classes.card}>

                <BlockingProgressItemHeader onClose={onClose}>
                    Dit niveau er stadig <LevelIconAndText cooperationLevel={cooperationLevel} />
                </BlockingProgressItemHeader>

                <div className={classes.paragraph}>
                    Øv, at opgaven ikke blev til noget – men dit niveau er stadig {levelText}.
                </div>

                <div className={classes.paragraph}>
                    Løs <span>{tasksUntilNextLevel} {tasksUntilNextLevel !== 1 ? "opgaver" : "opgave"}</span> for
                    at nå <LevelIconAndText cooperationLevel={nextCooperationLevel} />
                </div>

            </Paper>
        </Container>
    );
};
